import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { portcosAtomJ } from '../../../../services/state/PortCosStateJ';
import { templateAssignmentsByCompanyIdStateJ } from '../../../../services/state/KPI/KPICompaniesStateJ';
import { ICompanyDataModel } from '../../../../data-models/company.data-model';

export interface IKpiCompanyData extends ICompanyDataModel {
  assigned: boolean;
  templateUuids: string[];
}

export function useAllCompaniesRowData(): IKpiCompanyData[] {
  const portcos = useAtomValue(portcosAtomJ);
  const assignmentsByCompanyId = useAtomValue(templateAssignmentsByCompanyIdStateJ);

  return useMemo(() => {
    return portcos.map((company) => {
      const assignments = assignmentsByCompanyId.get(company.id) ?? [];
      return {
        ...company,
        assigned: assignmentsByCompanyId.has(company.id),
        templateUuids: assignments.map((a) => a.templateUuid),
      };
    });
  }, [assignmentsByCompanyId, portcos]);
}
